import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

export const FreeDeliveryChip: FC<ChipProps> = ({ className, size = 'medium' }) => {
  const { t } = useTranslation()

  return (
    <Chip className={className} color="greyV3" size={size}>
      {t('common:FREE_DELIVERY')}
    </Chip>
  )
}
